export function delay(func: () => any, time = 0): void {
  const timeout = window.setTimeout(() => {
    func()
    window.clearTimeout(timeout)
  }, time)
}
